import "./styles/global.css";
import ReactDOM from "react-dom/client";
import { ErrorBoundary } from "react-error-boundary";
import App from "./App";
import { ErrorHandler } from "./components/Error";
import reportWebVitals from "./reportWebVitals";

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement
);
root.render(
  <ErrorBoundary FallbackComponent={ErrorHandler}>
    <App />
  </ErrorBoundary>
);

reportWebVitals();
